import { render, staticRenderFns } from "./BuyerAccountDetails.vue?vue&type=template&id=3b6065d0&scoped=true"
import script from "./BuyerAccountDetails.vue?vue&type=script&lang=js"
export * from "./BuyerAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountDetails.vue?vue&type=style&index=0&id=3b6065d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6065d0",
  null
  
)

export default component.exports